'use client'

import React from 'react'

import { DatePicker } from './DatePicker'
import type { DatePickerProps } from './DatePicker'

export type TimePickerProps = Omit<
  DatePickerProps,
  'dateFormat' | 'showTimeSelect' | 'showTimeSelectOnly' | 'timeCaption'
> & {
  dateFormat?: string
  timeCaption?: string
}

/** Time-only preset of DatePicker with the shared application format. */
export const TimePicker = ({
  dateFormat = 'h:mm aa',
  timeCaption = 'Time',
  ...props
}: TimePickerProps) => (
  <DatePicker
    {...props}
    dateFormat={dateFormat}
    showTimeSelect
    showTimeSelectOnly
    timeCaption={timeCaption}
  />
)
